// extracted by mini-css-extract-plugin
module.exports = {"root":"productSort_shimmer_root__2gmE-","sortButtonShimmer":"productSort_shimmer_sortButtonShimmer__1KMPh"};